var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container u-pd-b-7"},[_c('div',{staticClass:"user-account _login"},[_c('div',{},[_c('div',{staticClass:"login_controller_area u-mg-t-4"},[_c('sign-up-action-panel',{attrs:{"regist-token":_vm.registToken}})],1)])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13ee1bc8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/IdentificationControllers.vue
// module id = null
// module chunks = 